import { JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import { useAppContext } from './context/appContext';
import Loading from './components/loading';
import ShoppingCart from './components/ShoppingCart';

const ProductList = () => {
  const {
    products,
    getProducts,
    isLoading,

    addProduct
  } = useAppContext();

  useEffect(() => {
    getProducts();
  }, []);

  if (isLoading) {
    return <Loading center />;
  }

  return (
    <>
      <ShoppingCart></ShoppingCart>
      <CardGroup>
        {products.map((product: { _id: Key | null | undefined; imageUrl: any; name: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; price: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; detail: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined; }) => (
          <Card key={product._id} style={{ width: '18rem' }}>
            <Card.Img variant="top" src={require(`../../assets/images/products/${product.imageUrl}`)} />
            <Card.Body>
              <Card.Title>{product.name}</Card.Title>
              <Card.Text>
                Price: <span>{product.price}</span> THB
              </Card.Text>
              <Card.Text>
                {product.detail}
              </Card.Text>
              <Button variant="primary" onClick={(e) => { 
                addProduct(product);
              }} >Add to cart</Button>
            </Card.Body>
          </Card>
        ))}
      </CardGroup>
    </>
  )
  
};

export default ProductList;
